import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { getActiveAIOperationFromState } from '../../../../store/StateControllers/Survey/SurveyResponse/AISurveyAgentController';
import { DataCollectionAiAgentOperationType } from '../../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseModels';

export const useAiActionTarget = (operationType?: DataCollectionAiAgentOperationType | null) => {
    const aiOperation = useSelector((state: ApplicationState) =>
        getActiveAIOperationFromState(state.aiSurveyAgentState, operationType)
    );
    const coreRequestId = useSelector((state: ApplicationState) =>
        state.surveyResponseState?.coreData?.request?.requestId
    );

    return {
        aiOperation,
        requestId: aiOperation?.requestId ?? coreRequestId ?? '',
        operationId: aiOperation?.operationId ?? ''
    };
};
